<template>
    <label>{{ $t('message.keyboard-select-language') }}:
        <select :name="getName()" @change="updateContent" :aria-label="getNameAria()">
            <option :value="langIndex" v-for="(item, langIndex) in getKeyboardList()" :key="langIndex" :selected="item.is_selected">{{ item.name }}</option>
        </select>
    </label>
</template>

<script>
export default {
    props: ['selectedLanguage'],
    methods: {
        getName() {
            return 'keyboard';
        },

        getNameAria() {
            return this.$t('message.keyboard-select-language');
        },

        updateContent(event) {
            const selectedLanguage = event.target.value;
            this.$emit('update', selectedLanguage);
        },

        getKeyboardList() {
            let keyboard_list = {
                'nob': {'name': this.$t('message.keyboard-norwegian'), 'is_selected': false},
                'ara': {'name': this.$t('message.keyboard-arabic'), 'is_selected': false},
                // 'mya': {'name': this.$t('message.keyboard-burmese'), 'is_selected': false},
                // 'prs': {'name': this.$t('message.keyboard-dari'), 'is_selected': false},
                'fil': {'name': this.$t('message.keyboard-filipino'), 'is_selected': false},
                'kmr': {'name': this.$t('message.keyboard-kurdish-kurmanji'), 'is_selected': false},
                'ckb': {'name': this.$t('message.keyboard-kurdish-sorani'), 'is_selected': false},
                'fas': {'name': this.$t('message.keyboard-persian'), 'is_selected': false},
                'pol': {'name': this.$t('message.keyboard-polish'), 'is_selected': false},
                'rus': {'name': this.$t('message.keyboard-russian'), 'is_selected': false},
                'tam': {'name': this.$t('message.keyboard-tamil'), 'is_selected': false},
                'ths': {'name': this.$t('message.keyboard-thai'), 'is_selected': false},
                'tir': {'name': this.$t('message.keyboard-tigrinja'), 'is_selected': false},
                'tur': {'name': this.$t('message.keyboard-turkish'), 'is_selected': false},
                'urd': {'name': this.$t('message.keyboard-urdu'), 'is_selected': false},
                'vie': {'name': this.$t('message.keyboard-vietnamese'), 'is_selected': false},
            };

            if (this.selectedLanguage && keyboard_list[this.selectedLanguage] != undefined) {
                keyboard_list[this.selectedLanguage]['is_selected'] = true;
            }

            return keyboard_list;
        }
    }
};
</script>
